function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7253 0H4.27556C1.57333 0 0 1.602 0 4.347V13.644C0 16.434 1.57333 18 4.27556 18H11.7253C14.4711 18 16 16.434 16 13.644V4.347C16 1.602 14.4711 0 11.7253 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.13733,
  y: 8.47058,
  width: 9.41177,
  height: 5.29412,
  rx: 2,
  fill: "#FFDD02"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.02876 4.24435V4.23535H7.44476C7.93733 4.23535 8.33733 4.55035 8.33733 4.93645C8.33733 5.33335 7.93733 5.64835 7.44476 5.64835H4.02876C3.53619 5.64835 3.13733 5.33335 3.13733 4.94635C3.13733 4.55935 3.53619 4.24435 4.02876 4.24435Z",
  fill: "#2A2A2F"
});

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Document.507a8ec5.svg";
export { ForwardRef as ReactComponent };